<template>
  <v-container fluid grid-list-lg px-0>
    <v-layout>
      <v-flex xs9>
        <template v-if="fetchingData">
          <div class="text-xs-center mt-4">
            <v-progress-circular :size="80" color="primary" indeterminate />
          </div>
        </template>
        <template v-else>
          <v-data-table light class="elevation-1" :headers="headers" :items="items" hide-actions no-data-text="Список индикаторов пуст">
            <template #headerCell="{ header }">
              <template v-if="header.type === 'checkbox'">
                <v-checkbox v-model="selectAllCategoriesAndIndicators" color="success" hide-details @change="toggleAllCategoriesAndIndicators()"></v-checkbox>
                <v-checkbox v-model="selectKPICategoriesAndIndicators" color="warning" hide-details @change="toggleKPICategoriesAndIndicators()"></v-checkbox>
              </template>
              <template v-else>
                {{ header.text }}
              </template>
            </template>
            <template #items="{ item }">
              <!-- category -->
              <template v-if="item.type === 'category'">
                <tr>
                  <td>
                    <v-checkbox v-model="selectedCategories" :value="item.code" color="success" hide-details @change="toggleAllIndicatorsInCategory(item)" />
                  </td>
                  <td :colspan="headers.length - 1" class="subheading">
                    <b>{{ item.sequence }}. {{ item.title[locale] }}</b>
                  </td>
                </tr>
              </template>
              <!-- Single indicator -->
              <template v-else-if="!item.parent && !item.children">
                <tr>
                  <td>
                    <v-checkbox v-model="selectedSingleIndicators" :value="item.id" color="success" hide-details @change="toggleSingleIndicator(item)"></v-checkbox>
                  </td>
                  <td class="text-sm-center px-0" style="vertical-align: top; text-align: center;">
                    <v-chip label small dark color="blue-grey">{{ categories[item.category].sequence }}.{{ item.sequence }}</v-chip>
                  </td>
                  <td class="subheading pl-0">
                    {{ item.title[locale] }}
                  </td>
                  <td class="text-sm-center">
                    <v-tooltip v-if="item.kpi" top>
                      <template #activator="{ on }">
                        <v-icon color="warning" v-on="on" small style="cursor: pointer;">grade</v-icon>
                      </template>
                      <span>{{ $t('hints.kpi_indicator') }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <!-- Parent indicator -->
              <template v-else-if="!item.parent && item.children">
                <tr>
                  <td>
                    <v-checkbox v-model="selectedParentIndicators" :value="item.id" color="success" hide-details @change="toggleParentIndicator(item)"></v-checkbox>
                  </td>
                  <td class="px-0" style="vertical-align: top;">
                    <v-chip label small dark color="blue-grey">{{ categories[item.category].sequence }}.{{ item.sequence }}</v-chip>
                  </td>
                  <td :colspan="2" class="subheading pl-0">
                    {{ item.title[locale] }}
                  </td>
                </tr>
              </template>
              <!-- Child indicator -->
              <template v-else>
                <tr>
                  <td>
                    <v-checkbox v-model="selectedChildIndicators" :value="item.id" color="success" hide-details @change="toggleChildIndicator(item)"></v-checkbox>
                  </td>
                  <td></td>
                  <td>
                    {{ item.sequence }}) {{ item.title[locale] }}
                  </td>
                  <td class="text-sm-center">
                    <v-tooltip v-if="item.kpi" top>
                      <template #activator="{ on }">
                        <v-icon color="warning" v-on="on" small style="cursor: pointer;">grade</v-icon>
                      </template>
                      <span>{{ $t('hints.kpi_indicator') }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </template>
          </v-data-table>
        </template>
      </v-flex>
      <v-flex xs3>
        <v-select
            v-model="selectedInstitution"
            label="Выберите институт"
            :items="institutions"
            :item-text="`title.${locale}`"
            item-value="code"
            no-data-text="Список пуст"
            :disabled="disabledFilter"
        />
        <v-select
            v-model="selectedDepartment"
            label="Выберите кафедру"
            :items="departments"
            :item-text="`title.${locale}`"
            item-value="code"
            no-data-text="Список пуст"
            :disabled="disabledFilter"
            :clearable="isUserSuperManager"
        />
        <v-btn color="primary" class="right" @click="calculateSummaryReport()" :disabled="calculating" :loading="calculating">
          Сформировать
          <template #loader>
            <span class="loader">
              <v-icon light>cached</v-icon>
            </span>
            {{ timer }}
          </template>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { sortBySequence } from '@/plugins/helpers'
import apiIndicators from '@/api/indicators'

export default {
  data: () => ({
    timer: '',
    fetchingData: false,

    calculating:false,

    disabledFilter: false,

    selectedInstitution: null,
    selectedDepartment: null,

    selectAllCategoriesAndIndicators: null,
    selectKPICategoriesAndIndicators: null,

    selectedCategories: [],
    selectedSingleIndicators: [],
    selectedParentIndicators: [],
    selectedChildIndicators: [],

    headers: [
      {
        text: '',
        align: 'center',
        sortable: false,
        type: 'checkbox'
      },
      {
        text: '',
        align: 'center',
        sortable: false,
        value: null
      },
      {
        text: 'Индикатор',
        align: 'left',
        sortable: false,
        value: 'title'
      },
      {
        text: 'Ключевой индикатор',
        align: 'center',
        sortable: false,
        class: 'multiline',
        value: null
      },
    ],
  }),
  computed: {
    locale () {
      return this.$i18n.locale
    },
    period () {
      return this.$route.params.period
    },
    userDepartment () {
      return this.$store.getters.userDepartment
    },
    isUserHead () {
      return this.$store.getters.isUserHead
    },
    isUserSuperManager () {
      return this.$store.getters.isUserSuperManager
    },

    items () {
      let items = []

      const categories = this.categories
      const indicators = this.indicators

      Object.values(categories)
        .sort(sortBySequence)
        .forEach((category) => {
          items.push({...category, type: 'category'})
          Object.values(indicators)
            .filter((indicator) => {
              return indicator.category === category.code
            })
            .sort(sortBySequence)
            .forEach((indicator) => {
              items.push({...indicator, type: 'indicator'})
              if (indicator.children) {
                Object.values(indicator.children)
                  .sort(sortBySequence)
                  .forEach((child) => {
                    items.push({ ...child, type: 'indicator' })
                  })
              }
            })
       })

      return items
    },
    categories () {
      return this.$store.getters['indicators/getCategories']
    },
    indicators () {
      return this.$store.getters['indicators/getIndicators']
    },
    institutions () {
      return Object.values(this.$store.getters['institutions/getInstitutions'])
          .sort((a, b) => a.title[this.locale].localeCompare(b.title[this.locale]))
    },
    departments () {
      return Object.values(this.$store.getters['departments/getDepartments'])
          .filter(department => department.institution.code === this.selectedInstitution)
          .sort((a, b) => a.title[this.locale].localeCompare(b.title[this.locale]))
    }
  },
  watch: {
    selectedInstitute () {
      this.selectedDepartment = null
    },
    selectedDepartment () {
      // this.calculateSummaryReport()
    },
    period () {
      this.init()
    }
  },
  async mounted() {
    await this.init()
  },
  methods: {
    async init () {
      this.fetchingData = true
      await this.loadInstitutions()
      await this.loadDepartments()
      await this.loadIndicators()

      if (this.institutions.length > 0) {
        this.selectedInstitution = this.institutions[0].code
      }

      this.selectAllCategoriesAndIndicators = true

      Object.values(this.categories).forEach(category => {
        this.selectedCategories.push(category.code)
        this.toggleAllIndicatorsInCategory(category)
      })

      if (this.isUserHead) {
        const department = this.$store.getters['departments/getDepartments'][this.userDepartment]
        this.selectedInstitution = department.institution.code
        this.selectedDepartment = this.userDepartment

        this.disabledFilter = true
      }

      this.fetchingData = false
    },
    async loadInstitutions () {
      try {
        await this.$store.dispatch('institutions/loadInstitutions')
      } catch (e) {
        this.$events.$emit('notify', {
          message: e.message,
          type: 'error'
        })
      }
    },
    async loadDepartments () {
      try {
        await this.$store.dispatch('departments/loadDepartments')
      } catch (e) {
        this.$events.$emit('notify', {
          message: e.message,
          type: 'error'
        })
      }
    },
    async loadIndicators () {
      try {
        await this.$store.dispatch('indicators/loadIndicators', this.period)
      } catch (e) {
        this.$events.$emit('notify', {
          message: e.message,
          type: 'error'
        })
      }
    },

    toggleAllCategoriesAndIndicators () {
      this.selectedCategories = []
      this.selectedParentIndicators = []
      this.selectedChildIndicators = []
      this.selectedSingleIndicators = []

      if (this.selectAllCategoriesAndIndicators) {

        this.selectKPICategoriesAndIndicators = false

        Object.values(this.categories).forEach(category => {
          this.selectedCategories.push(category.code)
        })

        Object.values(this.indicators).forEach(indicator => {
          if (!!indicator.children) {
            this.selectedParentIndicators.push(indicator.id)
            Object.values(indicator.children).forEach(child => {
              this.selectedChildIndicators.push(child.id)
            })
          } else {
            this.selectedSingleIndicators.push(indicator.id)
          }
        })
      }
    },

    toggleKPICategoriesAndIndicators () {
      this.selectedCategories = []
      this.selectedParentIndicators = []
      this.selectedChildIndicators = []
      this.selectedSingleIndicators = []

      if (this.selectKPICategoriesAndIndicators) {
        this.selectAllCategoriesAndIndicators = false

        Object.values(this.categories).forEach(category => {
          let isCategoryHasKPI = false

          Object.values(this.indicators).forEach(indicator => {
            if (!!indicator.children) {
              let isParentHasKPIChild = false
              Object.values(indicator.children).forEach(child => {
                if (child.kpi) {
                  this.selectedChildIndicators.push(child.id)
                  isParentHasKPIChild = true
                }
              })

              if (isParentHasKPIChild) {
                this.selectedParentIndicators.push(indicator.id)
                isCategoryHasKPI = true
              }
            } else {
              if (indicator.kpi) {
                this.selectedSingleIndicators.push(indicator.id)
                isCategoryHasKPI = true
              }
            }
          })

          if (isCategoryHasKPI) {
            this.selectedCategories.push(category.code)
          }
        })
      }
    },

    toggleAllIndicatorsInCategory (category) {
      const isCategorySelected = !!this.selectedCategories.find(c => c === category.code)

      const indicators = Object.values(this.indicators).filter(indicator => indicator.category === category.code)
      indicators.forEach(indicator => {
        if (!indicator.children) {
          const isSelected = !!this.selectedSingleIndicators.find(i => i === indicator.id)
          if (isCategorySelected && !isSelected) {
            this.selectedSingleIndicators.push(indicator.id)
          } else if(!isCategorySelected && isSelected) {
            const idx = this.selectedSingleIndicators.findIndex(i => i === indicator.id)
            this.selectedSingleIndicators.splice(idx, 1)
          }
        } else {
          const isSelected = !!this.selectedParentIndicators.find(i => i === indicator.id)
          if (isCategorySelected && !isSelected) {
            this.selectedParentIndicators.push(indicator.id)
          } else if (!isCategorySelected && isSelected) {
            const idx = this.selectedParentIndicators.findIndex(i => i === indicator.id)
            this.selectedParentIndicators.splice(idx ,1)
          }

          const children = Object.values(this.indicators[indicator.id]['children'])
          children.forEach(child => {
            const isChildSelected = !!this.selectedChildIndicators.find(i => i === child.id)
            if (isCategorySelected && !isChildSelected) {
              this.selectedChildIndicators.push(child.id)
            } else if (!isCategorySelected && isChildSelected) {
              const idx = this.selectedChildIndicators.findIndex(i => i === child.id)
              this.selectedChildIndicators.splice(idx, 1)
            }
          })
        }
      })
    },
    toggleSingleIndicator (indicator) {
      const isSelected = !!this.selectedSingleIndicators.find(i => i === indicator.id)

      // if (isSelected) {
      //
      // } else {
      //
      // }
    },
    toggleParentIndicator (parent) {
      const isSelected = !!this.selectedParentIndicators.find(i => i === parent.id)

      if (isSelected) {
        const isCategorySelected = !!this.selectedCategories.find(category => category === parent.category)
        if (!isCategorySelected) {
          this.selectedCategories.push(parent.category)
        }
      } else {
        const siblings = Object.values(this.indicators).filter(indicator => indicator.category === parent.category)
        let isCategoryHasIndicatorSelected = false
        siblings.forEach(sibling => {
          if (this.selectedParentIndicators.find(i => i === sibling.id)) {
            isCategoryHasIndicatorSelected = true
          }
        })
        if (!isCategoryHasIndicatorSelected) {
          const idx = this.selectedCategories.findIndex(category => category === parent.category)
          this.selectedCategories.splice(idx, 1)
        }
      }

      const children = Object.values(this.indicators[parent.id]['children'])

      children.forEach(child => {
        const isChildSelected = !!this.selectedChildIndicators.find(i => i === child.id)

        if (isSelected && !isChildSelected) {
          this.selectedChildIndicators.push(child.id)
        } else if (!isSelected && isChildSelected) {
          const idx = this.selectedChildIndicators.findIndex(i => i === child.id)
          this.selectedChildIndicators.splice(idx, 1)
        }
      })
    },
    toggleChildIndicator (indicator) {
      const isSelected = !!this.selectedChildIndicators.find(i => i === indicator.id)

      if (isSelected) {
        const isParentSelected = !!this.selectedParentIndicators.find(parent => parent === indicator.parent)
        if (!isParentSelected) {
          this.selectedParentIndicators.push(indicator.parent)

          const isCategorySelected = !!this.selectedCategories.find(category => category === indicator.category)
          if (!isCategorySelected) {
            this.selectedCategories.push(indicator.category)
          }
        }
      } else {
        const siblings = Object.values(this.indicators[indicator.parent]['children']).filter(i => i.parent === indicator.parent)
        let isParentHasChildrenSelected = false
        siblings.forEach(sibling => {
          if (this.selectedChildIndicators.find(i => i === sibling.id)) {
            isParentHasChildrenSelected = true
          }
        })
        if (!isParentHasChildrenSelected) {
          const idx = this.selectedParentIndicators.findIndex(parent => parent === indicator.parent)
          this.selectedParentIndicators.splice(idx, 1)

          const parentSiblings = Object.values(this.indicators).filter(i => i.category === indicator.category)
          let isCategoryHasIndicatorSelected = false
          parentSiblings.forEach(sibling => {
            if (this.selectedParentIndicators.find(i => i === sibling.id)) {
              isCategoryHasIndicatorSelected = true
            }
          })
          if (!isCategoryHasIndicatorSelected) {
            const idx = this.selectedCategories.findIndex(category => category === indicator.category)
            this.selectedCategories.splice(idx, 1)
          }
        }
      }
    },

    async calculateSummaryReport () {
      this.calculating = true
      this.timer = '00:00'
      const vm = this
      const start = new Date()
      let timer = setTimeout(function t () {
        vm.timer = new Date(new Date() - start).toISOString().substr(14, 5)
        timer = setTimeout(t, 500)
      }, 500)
      try {
        const selectedIndicators = [...this.selectedCategories, ...this.selectedParentIndicators, ...this.selectedChildIndicators, ...this.selectedSingleIndicators]
        const response = await apiIndicators.calculateSummaryReportTeachers(this.period, selectedIndicators, this.selectedInstitution, this.selectedDepartment)
        const headers = this.$store.getters.getResponseHeaders
        const header = headers['content-disposition']
        if (!header) {
          let result = await response.text();
          result = JSON.parse(result)
          throw new Error(result.message || 'Возникла ошибка')
        }
        const filename = header.substring(header.indexOf('"') + 1, header.lastIndexOf('"'))
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.href = url;
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
      } catch (e) {
        this.$events.$emit('notify', {
          message: e.message,
          type: 'error'
        })
      }
      clearTimeout(timer)
      this.calculating = false
    }
  }
}
</script>

<i18n>
{
  "ru": {
    "hints": {
      "kpi_indicator": "Ключевой индикатор"
    }
  },
  "kz": {
    "hints": {
      "kpi_indicator": "Кілттік көрсеткіш"
    }}
}
</i18n>

<style scoped>
.loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
